import { gql } from '@apollo/client';

const schema = {
  create: {
    name: 'createUserCategory',
    serviceName: 'unitadmin',
    query: gql`
      mutation createUserCategory($title: String!, $shop_id: String, $unit_id: String, $parent_id: String) {
        createUserCategory(title: $title, shop_id: $shop_id, unit_id: $unit_id, parent_id: $parent_id) {
          messages
        }
      }
    `,
  },
};

export default schema;
